// extracted by mini-css-extract-plugin
module.exports = {"chipON":"SymtomChip_chipON__1Go3K","chipLabelON":"SymtomChip_chipLabelON__2NVqW","chipOFF":"SymtomChip_chipOFF__29wN_","chipLabelOFF":"SymtomChip_chipLabelOFF__3tSAc"};